import { get, post, put, del } from './api';


export const getDashboardStats = () => {
  return get('/dashboard/stats');
};


export const getDashboardBranch = (id) => {
  return get(`/dashboard/branch-stats/${id}`);
};